module.exports = function(app) {
    app.controller('pages.register.recoveryInformation', ['$state', '$scope','$window', 'registrationUser','coremetrics', 'registration', 'contentResourceServices', 'registerNotifications', '$filter','brand',
        function($state, $scope, $window, registrationUser, coremetrics, registration, contentResourceServices, registerNotifications, $filter,brand) {

            coremetrics.startConversion('CONTACT INFORMATION STEP', 'REGISTRATION');

            $scope.scrollTo('chevron-container');

            $scope.brand_check = brand.current.sharedBrandCode;
            $scope.user = registrationUser.user;
            $scope.userType = $state.params.userType;

            if ($scope.userType === "medicareVisitor" || $scope.userType === "highmarkVisitor" ){
                $scope.typeUser="visitor";
            }
            if ($scope.userType === "medicareMember" || $scope.userType === "highmarkMember" ) {
                $scope.typeUser = "member";
            }
            if($scope.userType == 'medicareVisitor' || $scope.userType == 'highmarkVisitor'){
                $scope.chevron.parameters = { user : $scope.user };
            }else{
                $scope.chevron.parameters = { user : $scope.user, identifyResponse: registrationUser.identifyResponse };

            }
            $scope.notifications = [];
            var filterFn = registration.notificationFilter('alert', 'register.memberInformation');
            contentResourceServices.updateResourcesAsync(registerNotifications, filterFn, "Bluecore Notification").then(function(items){
                $scope.notifications = items;
            });
            $scope.updateCurrentChevronStep();

            $scope.nextStep = function() {
                if ($scope.contactInfoForm && $scope.contactInfoForm.$valid) {
                    coremetrics.elementTag('REGISTRATION:CONTACT INFORMATION NEXT', 'REGISTRATION');
                    coremetrics.finishConversion('CONTACT INFORMATION STEP', 'REGISTRATION');
                    $scope.currentNotification = '';
                    if($scope.userType == 'medicareVisitor' || $scope.userType == 'highmarkVisitor'){
                        registration.profile($scope.user).then(function(data) {
                            var stateParams =  { user : $scope.user, identifyResponse: data.data.payload };
                            $state.go($scope.getNextStateFromChevron(), stateParams);
                        }, function(error) {
                            var nf = $filter('filter')($scope.notifications, { id: error.returnCodeDescription });
                            $scope.currentNotification = (nf.length > 0 ? error.returnCodeDescription : registration.notifications.defaultError);
                        });
                    }else{
                        $state.go($scope.getNextStateFromChevron(),  $scope.chevron.parameters);
                    }
                }
            };

            $scope.cancelButton = function() {
                coremetrics.elementTag('REGISTRATION:CONTACT INFORMATION BACK', 'REGISTRATION');
                $scope.scrollTo('chevron-container');
                $state.go($scope.getPreviousStateFromChevron(),  $scope.chevron.parameters);
            };

        }
    ]);
};
